import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
import banner from '../../components/banner.vue';
import BannerButtonV2 from '../../components/banner-button-v2.vue';
import signLog from '@/components/sign-log';
import util from '@/common/util';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

export default {
    i18next: {
        ns: 'md-cta'
    },
    mixins: [spaceMixin(), colorMixin()],
    data: function() {
        return {
            sizeOption: {
                type: 'height',
                mobileType: 'height',
                height: 340,
                mobileHeight: 300
            },
            col1Picture: {
                src: '',
                mobileSrc: ''
            },
            maskOption: {
                showMask: true,
                maskColor: 'rgba(0,0,0,0.15)',
            },
            showOpacityLayer: true,
            col1Buttons: [],
            col1ButtonAlign: 'center',
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png'
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        col1PictureSrc() {
            return util.getImgSrcByPlatform(this.col1Picture, this.isMobile);
        },
        col2PictureSrc() {
            return util.getImgSrcByPlatform(this.col2Picture, this.isMobile);
        },
        finalButtons() { 
            this.col1Buttons.filter(buttonOption => {
                if (!buttonOption.text) {
                    return false;
                }
                switch (buttonOption.type) {
                case "utl":
                    return !!buttonOption.link;
                case "callback":
                    return (buttonOption.registerRole ?? "").trim() !== "";
                case "anchor":
                    return !!buttonOption.anchor;
                }
            })
        },
        hideDefault() {
            let { col1Type, col1PictureListOption } = this || {};
            if (col1Type == 'single') {
                return this.col1PictureSrc ? true : false;
            } else {
                let { list, mobileList } = col1PictureListOption || {};
                return list?.length || mobileList?.length ? true : false;
            }
        }
    },
    methods: {
        showRegisterPop(action) {
            if (action && action.type === 'callback') {
                let role = action.registerRole || '';
                let tag = action.tag || '';
                if (!this.user) {
                    signLog.register({
                        role,
                        registerData: {
                            tag
                        }
                    });
                } else {
                    util.toast(this.$t('md-cta.youAreAlreadyLogged'), 2000);
                }
            }
        },
        scrollToAnchor(anchor) {
            if (!anchor || util.isSSRServer) {
                return;
            }
            const element = document.querySelector(`[data-uuid="${anchor}"]`);
            if (element) {
                util.scrollIntoView(element, {
                    behavior: 'smooth',
                    block: 'start'
                });
                return true;
            } else if (process.env.NODE_ENV === 'development') {
                console.warn(`Anchor element with uuid "${anchor}" not found`);
            }
            return false;
        }
    },
    components: {
        banner,
        BannerButton: BannerButtonV2
    }
};
